/* ****
 * Aquí se concentrarán todas las url que usa axios para hacer las llamadas
 *
 **** */
import biomedica from '@/store/http/sections/biomedica'
import calidad from '@/store/http/sections/calidad'
import catalogos from '@/store/http/sections/catalogos'
import ceye from '@/store/http/sections/ceye'
import cocina from '@/store/http/sections/cocina'
import consulta from '@/store/http/sections/consulta'
import enfermeria from '@/store/http/sections/enfermeria'
import gld from '@/store/http/sections/gld'
import hc from '@/store/http/sections/hc'
import hospital from '@/store/http/sections/hospital'
import imagen from '@/store/http/sections/imagen'
import indicas from '@/store/http/sections/indicas'
import interna from '@/store/http/sections/interna'
import irsp from '@/store/http/sections/irsp'
import lavanderia from '@/store/http/sections/lavanderia'
import lab from '@/store/http/sections/lab'
import mantto from '@/store/http/sections/mantto'
import mecic from '@/store/http/sections/mecic'
import medicamentos from '@/store/http/sections/medicamentos'
import notas from '@/store/http/sections/notas'
import notasQx from '@/store/http/sections/notasQx'
import orto from '@/store/http/sections/orto'
import pacientes from '@/store/http/sections/pacientes'
import patologia from '@/store/http/sections/patologia'
import principal from '@/store/http/sections/principal'
import provs from '@/store/http/sections/provs'
import quirofano from '@/store/http/sections/quirofano'
import reportes from '@/store/http/sections/reportes'
import rhumanos from '@/store/http/sections/rhumanos'
import riesgo from '@/store/http/sections/riesgo'
import trascor from '@/store/http/sections/trascor'
import usuarios from '@/store/http/sections/usuarios'

export default {
    namespaced: true,

    state: {
        biomedica: biomedica,
        calidad: calidad,
        catalogos: catalogos,
        ceye: ceye,
        cocina: cocina,
        consulta: consulta,
        enfermeria: enfermeria,
        gld: gld,
        hc: hc,
        hospital: hospital,
        imagen: imagen,
        indicas: indicas,
        interna: interna,
        irsp: irsp,
        lavanderia: lavanderia,
        lab: lab,
        mantto: mantto,
        mecic: mecic,
        medicamentos: medicamentos,
        notas: notas,
        notasQx: notasQx,
        orto: orto,
        pacientes: pacientes,
        patologia:patologia,
        principal: principal,
        provs: provs,
        quirofano: quirofano,
        reportes: reportes,
        rhumanos: rhumanos,
        riesgo: riesgo,
        trascor: trascor,
        usuarios: usuarios,
    },
    mutations: {
        //        CAMBIA_FECHA(state, data){
        //            state.fecha = data
        //        },
    },
    actions: {
        //
    },
    getters: {
        //
    },
};
